import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const Tareas = React.lazy(() => import("../screean/task/tareas"));
export function tareas() {
  return (
    <Route
      path="/tareas"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <LazySuspense>
              <Tareas />
            </LazySuspense>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
